import ReactGA from 'react-ga4';

const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const isProduction = process.env.NODE_ENV === 'production';

export const initGA = () => {
  if (MEASUREMENT_ID && isProduction) {
    ReactGA.initialize(MEASUREMENT_ID);
    console.log('Google Analytics initialized with ID:', MEASUREMENT_ID);
  } else if (!isProduction) {
    console.log('Google Analytics disabled in development');
  } else {
    console.warn('Google Analytics Measurement ID not found');
  }
};

export const logPageView = (path: string) => {
  if (MEASUREMENT_ID && isProduction) {
    ReactGA.send({ hitType: 'pageview', page: path });
  }
};

export const logEvent = (category: string, action: string, label?: string) => {
  if (MEASUREMENT_ID && isProduction) {
    ReactGA.event({
      category,
      action,
      label,
    });
  }
};
